import styled from 'styled-components';
import { gridGap, justifyContent, padding, variant } from 'styled-system';
import { TableFooterProps } from './types';
import themeUtilities from '../../../../../theme/ThemeUtilities';

export const TableFooter = styled.div<TableFooterProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  border-top: 1px solid ${({ theme }) => theme.colors.gray.extraLight};
  flex-wrap: wrap;
  ${(props) =>
    variant(themeUtilities.getComponentVariant(props, 'Table', 'footer'))};
  ${justifyContent};
  ${padding};
  ${gridGap};
`;

TableFooter.defaultProps = {
  variant: 'default',
};
